/* @flow */

import type { NETGEM_API_V8_FEED_ITEM } from '../../../libs/netgemLibrary/v8/types/FeedItem';
import type { NETGEM_API_V8_HUB } from '../../../libs/netgemLibrary/v8/types/Hub';
import type { NETGEM_API_V8_LANG } from '../../../libs/netgemLibrary/v8/types/Lang';

export enum AvenueType {
  Explore,
  MyVideos,
  Other,
  Regular,
  Search,
}

export type BaseAvenue = {
  index: number,
  type: AvenueType,
};

export type TitledAvenue = {
  ...BaseAvenue,
  title: Array<NETGEM_API_V8_LANG>,
};

export type FocusedAvenue = {
  ...BaseAvenue,
  hub?: NETGEM_API_V8_HUB,
  hubItem?: NETGEM_API_V8_FEED_ITEM,
  isSearchFocusHidden?: boolean,
  searchString?: string,
};

export type NavigationStack = Array<FocusedAvenue>;
